<app-data-table
  [title]="title"
  [dataSource]="dataSource"
  [defaultPageSize]=""
  (rowClicked)="onRowClicked($event)"
  [useDefaultSearch]="false"
  [useCalculatedMaxHeight]="true"
  [titleIcon]="'block'"
  headerMargin="1rem"
  cardMargin="0">
  <ng-container class="card-header">
    <div class="header-actions">
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="'BackOffice.ManageContracts.OtherActions' | translate: locale.language">
          <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </ng-container>

</app-data-table>
<mat-menu #menu="matMenu">
    <a mat-menu-item color="primary" [routerLink]="['/back-office/contracts']" >
      <mat-icon>branding_watermark</mat-icon>
      {{ 'BackOffice.ManageContracts.Contract.TenantContracts' | translate: locale.language }}
    </a>
</mat-menu>